module.exports = __webpack_public_path__ + "img/cooperate9.a0c025d8.png";